// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"b3a7df2d","142":"e32ea7d5","162":"41fc2257","400":"f5f17551"}[chunkId] + ".chunk.js";
};